import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useIsNewProcessUiEnabled(): boolean {
    return useOctopusFeatureToggle("new-process-ui", false);
}
